import { Adapter as o, getAdapter as r } from "../../../../adapter.js";
import { ScopeAdapter as t } from "../../../scope/scope.adapter.js";
import { CashbackConfigurationModel as a } from "./cashbackConfiguration.model.js";
class m extends o {
  adapt(e) {
    return new a({
      id: e.id,
      code: e.code,
      scope: r(t).adapt(e.scope),
      baseRate: e.base_rate,
      status: e.status,
      name: e.name
    });
  }
  serialize(e) {
    throw new Error("Method not implemented.");
  }
}
export {
  m as CashbackConfigurationAdapter
};
//# sourceMappingURL=cashbackConfiguration.adapter.js.map
